
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/challenges/active/[[...challengeId]]",
      function () {
        return require("private-next-pages/challenges/active/[[...challengeId]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/challenges/active/[[...challengeId]]"])
      });
    }
  